<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <path
            d="M11.814.186c.248.249.248.65 0 .899L6.898 6l4.916 4.915c.248.249.248.65 0 .9-.124.123-.287.185-.45.185-.162 0-.325-.062-.449-.186L6 6.898l-4.915 4.916C.96 11.938.798 12 .635 12c-.162 0-.325-.062-.449-.186-.248-.248-.248-.65 0-.899L5.101 6 .186 1.085c-.248-.249-.248-.65 0-.899.248-.248.65-.248.899 0L6 5.102 10.915.186c.248-.248.651-.248.899 0z"
            transform="translate(-1276 -437) translate(128 415) translate(1148 22)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    isSecondary: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    color: function () {
      if (this.isError) return '#eb1212'
      if (this.isSuccess) return '#3da867'

      return this.isSecondary ? '#164194' : '#13A2E8'
    }
  }
}
</script>